import React from "react";

import { faCompress, faDownload, faExpand, faGear } from "@performyard/fontawesome/pro-regular-svg-icons";
import { ButtonStandard } from "@performyard/py-components";

import css from "../OrgChart.module.scss";

interface ChartToolbarProps {
	onExpandAll: () => void;
	onCollapseAll: () => void;
	onExportPng: () => void;
	onChangeFields?: () => void;
}

export function ChartToolbar({ onExpandAll, onCollapseAll, onExportPng, onChangeFields }: ChartToolbarProps) {
	return (
		<>
			<div data-interactive className={css.toolbar}>
				<ButtonStandard
					variant="outline"
					color="neutral"
					size="medium"
					iconLeft={faExpand}
					onClick={onExpandAll}
					dangerouslySetClassName="w-fit bg-white"
				>
					Expand All
				</ButtonStandard>
				<ButtonStandard
					variant="outline"
					color="neutral"
					size="medium"
					iconLeft={faCompress}
					onClick={onCollapseAll}
					dangerouslySetClassName="w-fit bg-white"
				>
					Collapse All
				</ButtonStandard>
			</div>
			<div data-interactive className={css.toolbarActions}>
				<ButtonStandard
					variant="outline"
					color="neutral"
					size="medium"
					iconLeft={faDownload}
					onClick={onExportPng}
					dangerouslySetClassName="w-fit bg-white"
				>
					Export PNG
				</ButtonStandard>
				{onChangeFields ? (
					<ButtonStandard
						variant="outline"
						color="neutral"
						size="medium"
						iconLeft={faGear}
						onClick={onChangeFields}
						dangerouslySetClassName="w-fit bg-white"
					>
						Change Fields
					</ButtonStandard>
				) : null}
			</div>
		</>
	);
}
